import serverProps from 'transfer/utils/serverProps'
import FullRecipientHeader from './recipient-header'
import SimpleRecipientHeader from './simple-recipient-header'

let RecipientHeader = SimpleRecipientHeader

const { env = '' } = serverProps

if (env === 'donate' || env === 'ppme') {
  RecipientHeader = FullRecipientHeader
}

export default RecipientHeader
